import { render, staticRenderFns } from "./RenewalComponent.vue?vue&type=template&id=5253fca0&scoped=true&"
import script from "./RenewalComponent.vue?vue&type=script&lang=js&"
export * from "./RenewalComponent.vue?vue&type=script&lang=js&"
import style0 from "./RenewalComponent.vue?vue&type=style&index=0&id=5253fca0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5253fca0",
  null
  
)

export default component.exports